import React, { useState, useEffect } from "react";
import Navigation from "../Navigation";

const Dashboard = () => {
  const [userData, setUserData] = useState([]);
  const [startIntervalDatafetch, setStartIntervalDatafetch] = useState(false);
  let intervalId = null;

  const fetchData = async () => {
    try {
      console.log("Fetching data...");
      const response = await fetch(`${process.env.REACT_APP_ADMIN}/qrCode/getAllData`);
      const data = await response.json();
      console.log("data----", data);
      setUserData(data);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  useEffect(() => {
    if (startIntervalDatafetch) {
      fetchData();
      intervalId = setInterval(() => { fetchData(); }, 1500);
    } else {
      clearInterval(intervalId);
    }
    return () => clearInterval(intervalId);
  }, [startIntervalDatafetch]);

  const checkedIn  = userData.filter((u) => u.checkIn === true).length;
  const checkedOut = userData.filter((u) => u.checkIn === false).length;
  const attendancePct = userData.length ? Math.round((checkedIn / userData.length) * 100) : 0;

  const gameZones = ['gameZone1', 'gameZone2', 'gameZone3', 'gameZone4'];
  const zoneColors = ['#e81b23', '#3b82f6', '#a855f7', '#22c55e'];
  const zoneGlows  = [
    'rgba(232,27,35,0.25)',
    'rgba(59,130,246,0.25)',
    'rgba(168,85,247,0.25)',
    'rgba(34,197,94,0.25)',
  ];

  return (
    <>
      <style>{css}</style>
      <div className="db-root">
        {/* Ambient orbs */}
        <div className="db-orb db-orb1" />
        <div className="db-orb db-orb2" />
        <div className="db-orb db-orb3" />
        {/* Dot grid */}
        <div className="db-grid" />

        <div className="db-card">
          <Navigation />

          <div className="db-content">

            {/* ── Header ── */}
            <div className="db-header">
              <div className="db-header-left">
                <div className="db-header-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <rect x="3" y="3" width="7" height="7" rx="1.5" stroke="#e81b23" strokeWidth="1.8"/>
                    <rect x="14" y="3" width="7" height="7" rx="1.5" stroke="#e81b23" strokeWidth="1.8"/>
                    <rect x="3" y="14" width="7" height="7" rx="1.5" stroke="#e81b23" strokeWidth="1.8"/>
                    <rect x="14" y="14" width="7" height="7" rx="1.5" stroke="rgba(232,27,35,0.5)" strokeWidth="1.8"/>
                  </svg>
                </div>
                <div>
                  <h1 className="db-title">Admin Dashboard</h1>
                  <p className="db-subtitle">
                    {startIntervalDatafetch
                      ? "Live — refreshing every 1.5s"
                      : `${userData.length} records loaded`}
                  </p>
                </div>
                {startIntervalDatafetch && <div className="db-live-badge"><span className="db-live-dot" />LIVE</div>}
              </div>

              <div className="db-btn-group">
                <button className="db-btn db-btn-secondary" onClick={fetchData}>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                    <path d="M1 4v6h6M23 20v-6h-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M20.49 9A9 9 0 005.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 013.51 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Fetch Data
                </button>
                <button
                  className={`db-btn ${startIntervalDatafetch ? "db-btn-stop" : "db-btn-start"}`}
                  onClick={() => setStartIntervalDatafetch(!startIntervalDatafetch)}
                >
                  {startIntervalDatafetch ? (
                    <>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                        <rect x="6" y="4" width="4" height="16" rx="1" fill="currentColor"/>
                        <rect x="14" y="4" width="4" height="16" rx="1" fill="currentColor"/>
                      </svg>
                      Stop Interval
                    </>
                  ) : (
                    <>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                        <path d="M10 8l6 4-6 4V8z" fill="currentColor"/>
                      </svg>
                      Start Interval
                    </>
                  )}
                </button>
              </div>
            </div>

            {/* ── Primary stat cards ── */}
            <div className="db-section-label">
              <span className="db-section-line" />
              <span className="db-section-text">Overview</span>
              <span className="db-section-line" />
            </div>

            <div className="db-stats-row">
              {/* Total Users */}
              <div className="db-stat-card" style={{"--delay":"0.05s"}}>
                <div className="db-stat-shimmer" />
                <span className="db-stat-label">Total Users</span>
                <span className="db-stat-value">{userData.length}</span>
                <div className="db-stat-bar-track">
                  <div className="db-stat-bar-fill" style={{width:"100%", background:"#e81b23"}} />
                </div>
              </div>

              {/* Checked In */}
              <div className="db-stat-card" style={{"--delay":"0.1s"}}>
                <div className="db-stat-shimmer" />
                <span className="db-stat-label">Checked In</span>
                <span className="db-stat-value" style={{color:"#22c55e"}}>{checkedIn}</span>
                <div className="db-stat-bar-track">
                  <div className="db-stat-bar-fill" style={{width:`${attendancePct}%`, background:"#22c55e", boxShadow:"0 0 8px rgba(34,197,94,0.6)"}} />
                </div>
                <span className="db-stat-pct">{attendancePct}% attendance</span>
              </div>

              {/* Checked Out */}
              <div className="db-stat-card" style={{"--delay":"0.15s"}}>
                <div className="db-stat-shimmer" />
                <span className="db-stat-label">Checked Out</span>
                <span className="db-stat-value" style={{color:"rgba(180,180,200,0.6)"}}>{checkedOut}</span>
                <div className="db-stat-bar-track">
                  <div className="db-stat-bar-fill" style={{
                    width: userData.length ? `${Math.round((checkedOut/userData.length)*100)}%` : "0%",
                    background:"rgba(180,180,200,0.4)"
                  }} />
                </div>
              </div>

              {/* Merch */}
              <div className="db-stat-card" style={{"--delay":"0.2s"}}>
                <div className="db-stat-shimmer" />
                <span className="db-stat-label">Merch Collected</span>
                <span className="db-stat-value" style={{color:"#eab308"}}>
                  {userData.filter((u) => u.merchCollected === true).length}
                </span>
                <div className="db-stat-bar-track">
                  <div className="db-stat-bar-fill" style={{
                    width: userData.length
                      ? `${Math.round((userData.filter(u=>u.merchCollected===true).length/userData.length)*100)}%`
                      : "0%",
                    background:"#eab308",
                    boxShadow:"0 0 8px rgba(234,179,8,0.5)"
                  }} />
                </div>
              </div>
            </div>

            {/* ── Game zone cards ── */}
            <div className="db-section-label">
              <span className="db-section-line" />
              <span className="db-section-text">Game Zones</span>
              <span className="db-section-line" />
            </div>

            <div className="db-zones-row">
              {gameZones.map((zone, index) => {
                const userCount   = userData.filter((u) => u[zone]).length;
                const playedCount = userData.reduce((total, u) => total + (u[zone] || 0), 0);
                const zonePct     = userData.length ? Math.round((userCount / userData.length) * 100) : 0;
                return (
                  <div
                    key={index}
                    className="db-zone-card"
                    style={{
                      "--zone-color": zoneColors[index],
                      "--zone-glow":  zoneGlows[index],
                      "--delay": `${0.05 + index * 0.07}s`,
                    }}
                  >
                    <div className="db-zone-topbar" style={{background: zoneColors[index], boxShadow:`0 0 10px ${zoneGlows[index]}`}} />
                    <span className="db-zone-name">Zone {index + 1}</span>

                    <div className="db-zone-stats">
                      <div className="db-zone-stat">
                        <span className="db-zone-stat-val" style={{color: zoneColors[index]}}>{userCount}</span>
                        <span className="db-zone-stat-lbl">Users</span>
                      </div>
                      <div className="db-zone-divider" />
                      <div className="db-zone-stat">
                        <span className="db-zone-stat-val" style={{color: zoneColors[index]}}>{playedCount}</span>
                        <span className="db-zone-stat-lbl">Plays</span>
                      </div>
                    </div>

                    <div className="db-stat-bar-track" style={{margin:"0 0 4px"}}>
                      <div className="db-stat-bar-fill" style={{
                        width:`${zonePct}%`,
                        background: zoneColors[index],
                        boxShadow:`0 0 8px ${zoneGlows[index]}`,
                      }} />
                    </div>
                    <span className="db-stat-pct">{zonePct}% participation</span>

                    <div className="db-zone-glow" style={{background:`radial-gradient(ellipse, ${zoneGlows[index]} 0%, transparent 70%)`}} />
                  </div>
                );
              })}
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;

/* ─── Styles ─────────────────────────────────────────────── */
const css = `
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  .db-root {
    position: fixed;
    inset: 0;
    background: linear-gradient(160deg, #0a0a0f 0%, #12121a 40%, #0d0d15 100%);
    overflow: hidden;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  }

  /* Dot grid */
  .db-grid {
    position: fixed; inset: 0;
    background-image: radial-gradient(rgba(232,27,35,0.1) 1px, transparent 1px);
    background-size: 36px 36px;
    pointer-events: none; z-index: 0;
    mask-image: radial-gradient(ellipse 80% 80% at 50% 20%, black 20%, transparent 100%);
    -webkit-mask-image: radial-gradient(ellipse 80% 80% at 50% 20%, black 20%, transparent 100%);
  }

  /* Orbs */
  .db-orb { position: fixed; border-radius: 50%; pointer-events: none; z-index: 0; }
  .db-orb1 {
    top:-15%; left:-10%; width:600px; height:600px;
    background: radial-gradient(circle, rgba(232,27,35,0.18) 0%, rgba(232,27,35,0.04) 50%, transparent 70%);
    filter: blur(8px); animation: orbFloat1 12s ease-in-out infinite;
  }
  .db-orb2 {
    bottom:-20%; right:-10%; width:700px; height:700px;
    background: radial-gradient(circle, rgba(180,10,18,0.14) 0%, rgba(120,0,10,0.05) 50%, transparent 70%);
    filter: blur(12px); animation: orbFloat2 16s ease-in-out infinite;
  }
  .db-orb3 {
    top:40%; left:30%; width:400px; height:400px;
    background: radial-gradient(circle, rgba(255,80,80,0.06) 0%, transparent 70%);
    filter: blur(20px); animation: orbFloat3 20s ease-in-out infinite;
  }

  /* Main card */
  .db-card {
    position: relative; z-index: 1;
    height: 100vh;
    background: rgba(14,14,20,0.88);
    backdrop-filter: blur(30px);
    -webkit-backdrop-filter: blur(30px);
    border: 1px solid rgba(255,255,255,0.06);
    box-shadow: 0 8px 64px rgba(0,0,0,0.6), inset 0 1px 0 rgba(255,255,255,0.05);
    overflow-y: auto;
    animation: cardReveal 0.7s cubic-bezier(0.22,1,0.36,1);
  }
  .db-card::-webkit-scrollbar { width: 6px; }
  .db-card::-webkit-scrollbar-track { background: rgba(255,255,255,0.03); border-radius:10px; }
  .db-card::-webkit-scrollbar-thumb { background: linear-gradient(180deg,#e81b23,#7b0008); border-radius:10px; }

  .db-content { padding: 28px 32px 48px; }

  /* ── Header ── */
  .db-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 32px;
    animation: fadeUp 0.5s cubic-bezier(0.22,1,0.36,1);
  }
  .db-header-left { display:flex; align-items:center; gap:14px; }
  .db-header-icon {
    width:46px; height:46px; border-radius:12px;
    background: rgba(232,27,35,0.1);
    border: 1px solid rgba(232,27,35,0.3);
    display:flex; align-items:center; justify-content:center; flex-shrink:0;
  }
  .db-title {
    font-size: 1.7rem; font-weight: 800;
    color: #f0f0f5; letter-spacing: 0.03em;
    text-shadow: 0 0 30px rgba(232,27,35,0.4);
  }
  .db-subtitle {
    font-size: 0.78rem; color: rgba(180,180,200,0.45);
    letter-spacing: 0.06em; margin-top: 3px;
  }
  .db-live-badge {
    display:flex; align-items:center; gap:6px;
    background: rgba(232,27,35,0.1);
    border: 1px solid rgba(232,27,35,0.3);
    border-radius: 20px; padding: 4px 12px;
    font-size: 0.68rem; font-weight:700; color:#e81b23; letter-spacing:0.1em;
  }
  .db-live-dot {
    width:7px; height:7px; border-radius:50%;
    background:#e81b23; display:inline-block;
    animation: livePulse 1.5s ease-in-out infinite;
  }

  /* Buttons */
  .db-btn-group { display:flex; gap:10px; flex-wrap:wrap; }
  .db-btn {
    display:flex; align-items:center; gap:8px;
    padding: 10px 20px; border:none; border-radius:10px;
    font-size:0.88rem; font-weight:700; cursor:pointer;
    letter-spacing:0.03em;
    transition: all 0.3s cubic-bezier(0.22,1,0.36,1);
    position:relative; overflow:hidden;
  }
  .db-btn::after {
    content:''; position:absolute; inset:0;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.15), transparent);
    background-size:200% 100%; background-position:-200% center;
    transition: background-position 0.4s ease;
  }
  .db-btn:hover::after { background-position: 200% center; }
  .db-btn-secondary {
    background: rgba(255,255,255,0.08);
    border: 1px solid rgba(255,255,255,0.12);
    color: #f0f0f5;
  }
  .db-btn-secondary:hover { background:rgba(255,255,255,0.13); transform:translateY(-2px); }
  .db-btn-start {
    background: #e81b23; color:#fff;
    box-shadow: 0 4px 16px rgba(232,27,35,0.35);
  }
  .db-btn-start:hover { background:#c8121a; transform:translateY(-2px); box-shadow:0 8px 24px rgba(232,27,35,0.5); }
  .db-btn-stop {
    background: rgba(220,53,69,0.15);
    border: 1px solid rgba(220,53,69,0.4);
    color: #ff6b6b;
  }
  .db-btn-stop:hover { background:rgba(220,53,69,0.22); transform:translateY(-2px); }

  /* Section divider */
  .db-section-label {
    display:flex; align-items:center; gap:12px;
    margin: 0 0 20px; padding: 0 2px;
  }
  .db-section-line { flex:1; height:1px; background:linear-gradient(90deg, transparent, rgba(232,27,35,0.3), transparent); }
  .db-section-text {
    font-size:0.7rem; font-weight:700;
    color:rgba(232,27,35,0.7); letter-spacing:0.14em; text-transform:uppercase; white-space:nowrap;
  }

  /* ── Primary stat cards ── */
  .db-stats-row {
    display:flex; gap:16px; flex-wrap:wrap;
    margin-bottom:32px;
  }
  .db-stat-card {
    flex:1; min-width:180px;
    position:relative; overflow:hidden;
    background: linear-gradient(160deg, #111118 0%, #0c0c14 100%);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius:18px;
    padding: 22px 22px 18px;
    display:flex; flex-direction:column; gap:6px;
    box-shadow: 0 4px 24px rgba(0,0,0,0.45), inset 0 1px 0 rgba(255,255,255,0.05);
    transition: transform 0.4s cubic-bezier(0.22,1,0.36,1), box-shadow 0.4s ease, border-color 0.4s ease;
    animation: fadeUp 0.6s cubic-bezier(0.22,1,0.36,1) var(--delay,0s) backwards;
  }
  .db-stat-card:hover {
    transform: translateY(-6px) scale(1.01);
    border-color: rgba(232,27,35,0.3);
    box-shadow: 0 12px 36px rgba(232,27,35,0.12), inset 0 1px 0 rgba(255,255,255,0.07);
  }
  .db-stat-shimmer {
    position:absolute; inset:0;
    background: linear-gradient(90deg, transparent, rgba(232,27,35,0.05), transparent);
    background-size:200% 100%;
    animation: shimmer 5s linear infinite;
    pointer-events:none;
  }
  .db-stat-label {
    font-size:0.7rem; font-weight:700;
    color:rgba(232,27,35,0.7); letter-spacing:0.12em; text-transform:uppercase;
  }
  .db-stat-value {
    font-size:2.4rem; font-weight:900;
    color:#f0f0f5; letter-spacing:-0.02em; line-height:1;
    animation: countUp 0.5s ease-out;
  }
  .db-stat-bar-track {
    width:100%; height:3px; border-radius:3px;
    background:rgba(255,255,255,0.07); overflow:hidden;
    margin-top: 4px;
  }
  .db-stat-bar-fill {
    height:100%; border-radius:3px;
    transition: width 1s cubic-bezier(0.22,1,0.36,1);
    animation: barGrow 1s cubic-bezier(0.22,1,0.36,1);
  }
  .db-stat-pct {
    font-size:0.68rem; color:rgba(180,180,200,0.4);
    letter-spacing:0.05em; text-align:right;
  }

  /* ── Zone cards ── */
  .db-zones-row {
    display:flex; gap:16px; flex-wrap:wrap;
    margin-bottom:32px;
  }
  .db-zone-card {
    flex:1; min-width:180px;
    position:relative; overflow:hidden;
    background: linear-gradient(160deg, #111118 0%, #0c0c14 100%);
    border: 1px solid rgba(255,255,255,0.07);
    border-radius:18px;
    padding: 0 0 18px;
    display:flex; flex-direction:column; align-items:center;
    box-shadow: 0 4px 24px rgba(0,0,0,0.45), inset 0 1px 0 rgba(255,255,255,0.04);
    transition: transform 0.4s cubic-bezier(0.22,1,0.36,1), box-shadow 0.4s ease, border-color 0.4s ease;
    animation: fadeUp 0.6s cubic-bezier(0.22,1,0.36,1) var(--delay,0s) backwards;
  }
  .db-zone-card:hover {
    transform: translateY(-6px) scale(1.02);
    border-color: var(--zone-color, rgba(255,255,255,0.2));
    box-shadow: 0 12px 36px var(--zone-glow, rgba(0,0,0,0.3));
  }
  .db-zone-topbar { width:100%; height:4px; }
  .db-zone-name {
    font-size:0.68rem; font-weight:700;
    color:rgba(180,180,200,0.5); letter-spacing:0.12em;
    text-transform:uppercase; margin:16px 0 12px;
  }
  .db-zone-stats { display:flex; align-items:center; gap:0; margin-bottom:14px; }
  .db-zone-stat { display:flex; flex-direction:column; align-items:center; gap:3px; padding:0 20px; }
  .db-zone-stat-val { font-size:1.9rem; font-weight:900; letter-spacing:-0.02em; line-height:1; animation:countUp 0.5s ease-out; }
  .db-zone-stat-lbl { font-size:0.65rem; color:rgba(180,180,200,0.45); letter-spacing:0.08em; text-transform:uppercase; }
  .db-zone-divider { width:1px; height:36px; background:rgba(255,255,255,0.08); }
  .db-zone-glow {
    position:absolute; bottom:0; left:50%; transform:translateX(-50%);
    width:140%; height:50%; pointer-events:none; z-index:0;
  }
  .db-stat-bar-track { width:calc(100% - 32px); }

  /* ── Keyframes ── */
  @keyframes orbFloat1 {
    0%,100%{transform:translate(0,0) scale(1)} 33%{transform:translate(60px,-80px) scale(1.15)} 66%{transform:translate(-40px,40px) scale(0.9)}
  }
  @keyframes orbFloat2 {
    0%,100%{transform:translate(0,0) scale(1)} 33%{transform:translate(-70px,50px) scale(1.1)} 66%{transform:translate(50px,-60px) scale(0.95)}
  }
  @keyframes orbFloat3 {
    0%,100%{transform:translate(0,0) scale(1)} 50%{transform:translate(40px,60px) scale(1.2)}
  }
  @keyframes cardReveal {
    from{opacity:0;transform:translateY(16px)} to{opacity:1;transform:translateY(0)}
  }
  @keyframes fadeUp {
    from{opacity:0;transform:translateY(24px)} to{opacity:1;transform:translateY(0)}
  }
  @keyframes shimmer {
    0%{background-position:-200% center} 100%{background-position:200% center}
  }
  @keyframes countUp {
    from{opacity:0;transform:translateY(8px)} to{opacity:1;transform:translateY(0)}
  }
  @keyframes barGrow {
    from{width:0!important} to{}
  }
  @keyframes livePulse {
    0%,100%{opacity:1;transform:scale(1)} 50%{opacity:0.3;transform:scale(0.85)}
  }

  @media (max-width:768px) {
    .db-stats-row, .db-zones-row { flex-direction:column; }
    .db-content { padding:20px 16px 40px; }
    .db-title { font-size:1.3rem; }
    .db-header { flex-direction:column; align-items:flex-start; }
  }

  /* Keep existing Grid.css keyboard / dialog overrides */
  .css-pmwqla-MuiPaper-root-MuiDialog-paper { background-color:black !important; }
  .keyboard { position:absolute; top:100%; min-width:1000px; width:100%; margin-top:20%; }
`;